  import { KeenIcon } from '@/components';
import { ManagePrompts } from './ManagePrompts';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const Prompts = ({ isOpen, onToggle }) => {
  return (
    <div>
      <button
        onClick={onToggle}
        className={`w-full flex items-center justify-between py-2 px-4 border border-gray border-opacity-50 
          ${isOpen ? 'bg-gray-200' : 'bg-white'} rounded-md hover:bg-gray-200 transition-colors`}
      >
        <div className='text-sm font-semibold'>
          <KeenIcon icon="feather" className="mr-2" />
          <FormattedMessage id="AGENTS.BUILDER.PROMPTS" />
        </div>  
        <span className="text-gray-500">
          {isOpen ? <KeenIcon icon="down" /> : <KeenIcon icon="right" />}
        </span>
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'opacity-100 mt-3' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="space-y-2 border rounded-lg">
          <div className="p-3 rounded-lg">
            <ManagePrompts type = "prompts"/>
          </div>
        </div>
      </div>
    </div>
  );
};

Prompts.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export { Prompts };
